import { getIPC } from './ipc.js';

/**
 * Enables the sending of ANR messages to the main process.
 */
function enableAnrRendererMessages(options) {
    const config = {
        pollInterval: 1000,
        anrThreshold: 5000,
        captureStackTrace: false,
        ...options,
    };
    const ipc = getIPC();
    // eslint-disable-next-line no-restricted-globals
    ipc.sendStatus({ status: document.visibilityState, config });
    setInterval(() => {
        ipc.sendStatus({ status: 'alive', config });
    }, config.pollInterval);
}

export { enableAnrRendererMessages };
